import { debounce } from '../../../static/template-gispen/js/utils/debounce';

class Video {
  static options = {
    threshold: 0,
    debounceTime: 100,
    mobileBreakpoint: 720,
    autoplay: false,
  };

  _state = {
    mobile: false,
  };

  constructor(element, options = {}) {
    this._element = element;
    this._options = { ...options, ...Video.options };
    this._video = this._element.querySelector('.player');
    this._options.autoplay = this._options.showControls === 'false' ? true : false;
    this._resize = this._resize.bind(this);
    this._addListeners = this._addListeners.bind(this);
    this._handleIntersect = this._handleIntersect.bind(this);
    this._playVideo = this._playVideo.bind(this);
    this._init();
    this._resize();
    this._addListeners();
  }

  _init() {
    return this._controlsActivated() ? this._enableControls() : this._disableControls();
  }

  _controlsActivated() {
    return this._options.controls === 'true';
  }

  _enableControls() {
    this._video.setAttribute('controls', 'controls');
    this._video.removeAttribute('loop');
    this._video.removeAttribute('muted');
    this._video.removeAttribute('autoplay');
    this._video.volume = 1;
    this._video.muted = false;
  }

  _disableControls() {
    this._video.removeAttribute('controls');
    this._video.setAttribute('loop', '');
    this._video.setAttribute('muted', 'muted');
    this._video.setAttribute('autoplay', 'true');
  }

  _resize() {
    this._state.mobile =
      window.innerWidth < this._options.mobileBreakpoint ||
      document.documentElement.clientWidth < this._options.mobileBreakpoint ||
      document.body.clientWidth < this._options.mobileBreakpoint;
  }

  _handleIntersect(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        this._playVideo();
        entry.target.setAttribute('data-inview', 'true');
      } else {
        entry.target.setAttribute('data-inview', 'false');
        entry.target.setAttribute('data-transition', '');
      }
    });
  }

  _playVideo() {
    if (!this._state.mobile && this._options.showControls === 'false') {
      this._video.play();
      if (this._video.currentTime && this._video.currentTime > 0) {
        this._video.currentTime = 0;
      }
    }
  }

  _addListeners() {
    window.addEventListener(
      'resize',
      debounce(() => {
        this._resize();
      }, this._options.debounceTime)
    );

    this._video.addEventListener('click', () => {
      if (this._state.mobile) {
        this._video.play();
      }
    });

    const options = this._options.threshold;

    this.intersectionObserver = new IntersectionObserver(this._handleIntersect, {
      options,
    });

    this.intersectionObserver.observe(this._element);
  }
}

export default Video;
